import React from 'react';

import Shell from './Shell';

interface Props {
  children: React.ReactNode;
}

/** The home page's shell: no header search (the hero has it). */
const LayoutNirmalxHome = ({ children }: Props) => <Shell variant="home">{ children }</Shell>;

export default LayoutNirmalxHome;
